import { CustomError } from '@/utils'
import { IWalletConnectOptions, PsbtSignOptions, TransactionOptions } from '@/wallets'
import { BaseWallet } from '@/wallets/BaseWallet'

// this class is used for wallets that are not installed
export class NotInstallWallet extends BaseWallet {
  installUrl = ''
  name = ''
  key = ''

  constructor({ installUrl, name }: { installUrl: string; name: string }) {
    super()
    this.installUrl = installUrl
    this.name = name
  }

  isInstalled(): boolean {
    return false
  }

  priority(): number {
    return -1
  }

  async getCompressedPublicKey(_network: string): Promise<string> {
    return ''
  }

  signPsbt(_psbt: string, _network: string, _options?: PsbtSignOptions): Promise<string> {
    throw new CustomError(`${this.name} Wallet is not installed`)
  }

  disconnect(_networkId?: string): Promise<void> {
    return Promise.resolve()
  }

  async connect(_network: string, options: IWalletConnectOptions) {
    this.download()
    return {
      address: '',
      networkInfo: options.network,
      compressedPublicKey: '',
    }
  }

  async getAddress(_networkId: string): Promise<string> {
    return ''
  }

  sendTransaction(
    _toAddress: string,
    _amount: number | bigint,
    _network: string,
    _options?: TransactionOptions
  ): Promise<string> {
    throw new CustomError(`${this.name} Wallet is not installed`)
  }

  signMessage(_message: string, _network: string): Promise<string> {
    throw new CustomError(`${this.name} Wallet is not installed`)
  }

  private download(): void {
    throw new CustomError(
      `${this.name} Wallet is not installed! <a target="_blank" class="underline" href="${this.installUrl}">Download wallet</a>`
    )
  }
}
